import { getLocalizedValue, getAttrValue } from "@grandvisionhq/utils";
import { getLineItemImageUrl } from "./get-line-item-image-url.js";
import { getProductTag } from "./get-product-tag.js";
import { getPrice } from "./legacy-get-price.js";
const parseCTUpsellData = (upsellProducts, locale, getLabel) => {
  if (!upsellProducts || upsellProducts.length === 0) {
    return [];
  }
  return upsellProducts.reduce((storedUpsellProducts, solution, index) => {
    const { masterVariant, name } = solution;
    const price = getPrice(masterVariant.prices);
    if (price === void 0 || index > 3) {
      return storedUpsellProducts;
    }
    const title = getLocalizedValue(name, locale);
    const sku = masterVariant.sku ?? "";
    const imageUrl = getLineItemImageUrl(masterVariant);
    const solutionType = getAttrValue(masterVariant, "solutionType");
    const volume = getAttrValue(masterVariant, "volume");
    const tag = getProductTag(masterVariant.tags?.[0], locale);
    const availability = masterVariant.availability;
    const channelsMap = availability?.channels ? Object.entries(availability.channels) : [];
    const hasAvailableQuantity = channelsMap.some(([, channel]) => channel.availableQuantity);
    const isAvailable = !availability ? true : hasAvailableQuantity;
    if (!isAvailable) {
      return storedUpsellProducts;
    }
    let body;
    if (solutionType && volume) {
      body = `${solutionType}, ${volume}${getLabel("products.unit.metric.liter.milli.abbr")}`;
    }
    const product = {
      title,
      body,
      imageUrl,
      sku,
      price,
      tag: tag ?? null
    };
    return [...storedUpsellProducts, product];
  }, []);
};
export {
  parseCTUpsellData
};
//# sourceMappingURL=parse-ct-upsell-data.js.map
